<template>
  <v-main>
    <a-header />
    <p-form
      ref="dataform"
      caption="Konum"
      :actions="formActions"
      :models="models"
      :autoCloseAfter="true"
      :refreshHook="refreshDataGrid"
      :defaultValues="{status: true}"
    >
      <template slot="content">
        <v-container fluid>
          <v-row>
            <v-col cols="3">
              <v-select
                dense
                label="Durum"
                v-model="models.status"
                :items="[
                  { value: false, text: 'Pasif' },
                  { value: true, text: 'Aktif' },
                ]"
                :rules="validation().required().toRules('Durum')"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                v-model="models.merchant_id"
                label="Şirket No"
                dense
                :rules="validation().required().numeric().toRules('Şirket No')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="models.id"
                label="Konum ID"
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="models.location_name"
                label="Konum Adı"
                dense
                :rules="validation().required().toRules('Şirket No')"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </p-form>
    <p-datagrid
      ref="datagridInstance"
      :url="gridUrl"
      :selectable="gridSelectable"
      :uniqueColumn="gridUniqueColumn"
      :headers="gridHeaders"
      :exportable="gridExportable"
      :clearable="gridClearable"
      :filters="gridFilters"
      :rowActions="gridRowActions"
      :massActions="gridMassActions"
      :actions="gridActions"
      :searchable="gridSearchable"
      :icon="gridIcon"
      :caption="gridCaption"
    />
    <a-footer />
  </v-main>
</template>

<script>
export default {
  name: "locations",
  components: {},
  data: (vm) => ({
    inEdit: false,
    gridUrl: "/setup/locationList",
    gridClearable: true,
    gridSearchable: true,
    gridSelectable: false,
    gridExportable: true,
    gridUniqueColumn: "id",
    gridIcon: "location_city",
    gridCaption: "Konumlar",
    gridHeaders: [
      {
        text: "İşlemler",
        value: "action",
        sortable: false,
        unExportable: true,
      },
      { text: "ID", value: "id", align: "center", sortable: true },
      { text: "Konum Adı", value: "location_name", sortable: true },
      { text: "Şirket Kodu", value: "merchant_id", sortable: true },
      {
        text: "Durum",
        value: "status",
        sortable: false,
        callable(item) {
          return item.status ? "Aktif" : "Pasif";
        },
        format: (item) => {
          return item.status ? "green--text" : "red--text";
        },
      },
    ],
    gridFilters: [
      {
        type: "text",
        name: "merchant_id",
        label: "Şirket Kodu",
      },
      {
        type: "text",
        name: "location_name",
        label: "Konum Adı",
      },
      {
        type: "select",
        name: "status",
        label: "Durum",
        lookups: [
          { value: true, text: "Aktif" },
          { value: false, text: "Pasif" },
        ],
      },
    ],
    gridMassActions: [],
    gridRowActions: [
      {
        icon: "edit",
        hint: "Düzenle",
        color: "blue",
        action: (item) => {
          vm.inEdit = true;
          vm.$refs.dataform.showFetch(item, "edit", "Düzenle");
        },
      },
      {
        icon: "delete",
        hint: "Sil",
        color: "red",
        warn: true,
        action: async (item, self) => {
          try {
            await vm.axios.delete("/setup/location/" + encodeURI(item.id));
            vm.$refs.datagridInstance.refresh();
          } catch (error) {
            vm.$dialog.error({ text: this.utils.getErrorMessage(error) });
          }
        },
        guard: (item, self) => {
          return true;
        },
      },
    ],
    gridActions: [
      {
        action: () => {
          vm.inEdit = false;
          vm.$refs.dataform.show("Ekle");          
        },
      },
    ],
    //END OF DATAGRID

    //FORM
    models: {
      id: null,
      location_name: null,
      merchant_id: null,
      status: null,
    },
    formActions: [
      {
        text: "Kaydet",
        api: {
          url: `/setup/createLocation`,
          method: "put",
        },
        condition: null,
      },
      {
        text: "Güncelle",
        fetch: {
          url: "/setup/location/",
          id: "id",
        },
        api: {
          url: "/setup/updateLocation",
          method: "patch",
        },
        condition: "edit",
      },
    ],
  }),
  computed: {},
  watch: {},
  methods: {
    refreshDataGrid() {
      this.$refs.datagridInstance.refresh();
    },
  },
  async mounted() {},
  created() {},
};
</script>